import request from "@/api/request";

//修改用户昵称
export function updateUserName(param) {
  return request({
    url: "/api/kp/user/updateUserName",
    method: "post",
    params: param,
  });
}
//修改图片
export function updateImage(query) {
  return request({
    url: "/api/kp/user/updateImage",
    method: "post",
    params: query,
  });
}
